import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MeteorologiaRoutingModule } from './meteorologia-routing.module';

@NgModule({
	imports: [CommonModule, MeteorologiaRoutingModule],
})
export class MeteorologiaModule {}
